export const blockIconsHardwareLaptopMac = (
	<span className='material-symbols-outlined'>laptop_mac</span>
);
